import { render } from "./AiPostsPage.vue?vue&type=template&id=44a52744"
import script from "./AiPostsPage.vue?vue&type=script&lang=js"
export * from "./AiPostsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__